/* Optional complements: never add a default color or calculate discounts locally. */
(() => {
  if (customElements.get('rovixo-cart-upsells')) return;
  let adding = false;
  document.addEventListener('click', event => {
    if (adding && event.target.closest('cart-remove-button, quantity-input button')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  class RovixoCartUpsells extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('change', event => {
        // Dawn CartItems handles bubbled changes as quantity changes.
        event.stopPropagation();
        const select = event.target.closest('[data-rx-select]');
        if (!select) return;
        const card = select.closest('[data-rx-card]');
        const option = select.selectedOptions[0];
        const valid = !!select.value && !option.disabled;
        card.querySelector('[data-rx-add]').disabled = adding;
        if (!valid) return;
        card.querySelector('[data-rx-price]').textContent = option.dataset.price;
        const compare = card.querySelector('[data-rx-compare]');
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
        const image = card.querySelector('[data-rx-image]');
        if (image && option.dataset.image) image.src = option.dataset.image;
        card.querySelector('[data-rx-error]').hidden = true;
        select.removeAttribute('aria-invalid');
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-rx-add]');
        if (!button) return;
        event.preventDefault();
        this.add(button);
      });
    }
    async add(button) {
      if (adding || document.querySelector('.cart__items--disabled')) return;
      const card = button.closest('[data-rx-card]');
      const select = card.querySelector('[data-rx-select]');
      const error = card.querySelector('[data-rx-error]');
      if (!select.value || !select.selectedOptions[0] || select.selectedOptions[0].disabled) {
        error.textContent = 'בחרו צבע לפני ההוספה לעגלה.';
        error.hidden = false;
        select.setAttribute('aria-invalid', 'true');
        select.focus();
        return;
      }
      select.removeAttribute('aria-invalid');
      const drawer = document.querySelector('cart-drawer');
      const inDrawer = !!this.closest('cart-drawer');
      const fromProduct = !!this.closest('[data-rx-product-section]');
      const productSection = document.querySelector('[data-rx-product-section]');
      if (productSection && productSection.cancelRefresh) productSection.cancelRefresh();
      const pageItems = document.getElementById('main-cart-items');
      const pageFooter = document.getElementById('main-cart-footer');
      const sections = ['cart-drawer', 'cart-icon-bubble'];
      if (pageItems) sections.push(pageItems.dataset.id);
      if (pageFooter) sections.push(pageFooter.dataset.id);
      if (productSection) sections.push(productSection.dataset.rxProductSection);
      const locked = Array.from(document.querySelectorAll('[name="checkout"], [data-rx-add], [data-rx-select], cart-drawer-items input[name="updates[]"], cart-items input[name="updates[]"]'));
      const prior = locked.map(el => [el, el.disabled]);
      locked.forEach(el => el.disabled = true);
      adding = true;
      error.hidden = true;
      button.textContent = 'מוסיף…';
      let committed = false;
      try {
        const response = await fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items: [{id: Number(select.value), quantity: 1}], sections, sections_url: location.pathname})
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'לא ניתן להוסיף כרגע. נסו שוב.');
        committed = true;
        // If rendering fails after an accepted add, recover without adding twice.
        if (sections.some(id => !result.sections || !result.sections[id])) throw new Error('render');
        // Dawn's native product form normally clears this outer state before
        // renderContents. Our custom add must do so too, including an empty cart.
        if (drawer) drawer.classList.remove('is-empty');
        const parse = html => new DOMParser().parseFromString(html, 'text/html');
        for (const container of [pageItems, pageFooter]) {
          if (!container) continue;
          const source = parse(result.sections[container.dataset.id]).querySelector('.js-contents');
          const target = container.querySelector('.js-contents');
          if (!source || !target) throw new Error('render');
          target.innerHTML = source.innerHTML;
        }
        if (productSection) {
          const source = parse(result.sections[productSection.dataset.rxProductSection]).querySelector('[data-rx-product-content]');
          if (!source) throw new Error('render');
          productSection.querySelector('[data-rx-product-content]').innerHTML = source.innerHTML;
        }
        if (drawer && (inDrawer || fromProduct)) {
          if (fromProduct) drawer.setActiveElement(productSection.querySelector('h2'));
          const scroller = drawer.querySelector('cart-drawer-items');
          const scrollTop = scroller ? scroller.scrollTop : 0;
          drawer.renderContents(result);
          const updatedScroller = drawer.querySelector('cart-drawer-items');
          if (updatedScroller) updatedScroller.scrollTop = scrollTop;
          // Rebind Dawn's focus trap after replacing its dialog contents.
          const dialog = drawer.querySelector('.drawer__inner');
          const focus = drawer.querySelector('.rx-upsells__heading') || drawer.querySelector('[name="checkout"]');
          if (dialog && typeof trapFocus === 'function') trapFocus(dialog, focus);
        } else {
          if (drawer) {
            const next = parse(result.sections['cart-drawer']).querySelector('.drawer__inner');
            if (next) drawer.querySelector('.drawer__inner').innerHTML = next.innerHTML;
          }
          const bubble = document.getElementById('cart-icon-bubble');
          const nextBubble = parse(result.sections['cart-icon-bubble']).querySelector('.shopify-section');
          if (bubble && nextBubble) bubble.innerHTML = nextBubble.innerHTML;
          const focus = pageItems && (pageItems.querySelector('.rx-upsells__heading') || document.querySelector('#checkout'));
          if (focus) focus.focus({preventScroll:true});
        }
      } catch (cause) {
        if (committed) {
          location.assign(window.routes.cart_url);
          return;
        }
        error.textContent = (cause instanceof TypeError || cause instanceof SyntaxError) ? 'לא התקבל אישור להוספה. בדקו את העגלה לפני ניסיון נוסף.' : cause.message;
        error.hidden = false;
      } finally {
        adding = false;
        prior.forEach(([el, disabled]) => { if (el.isConnected) el.disabled = disabled; });
        if (button.isConnected) button.textContent = 'הוספה +';
      }
    }
  }
  customElements.define('rovixo-cart-upsells', RovixoCartUpsells);
  class RovixoProductComplements extends HTMLElement {
    connectedCallback() {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
      }
    }
    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      this.cancelRefresh();
    }
    cancelRefresh() {
      if (this.controller) this.controller.abort();
    }
    async refresh() {
      this.cancelRefresh();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const url = new URL(location.href);
      url.searchParams.set('section_id', this.dataset.rxProductSection);
      try {
        const response = await fetch(url, {signal});
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = doc.querySelector('[data-rx-product-content]');
        if (!signal.aborted && this.isConnected && content) this.querySelector('[data-rx-product-content]').innerHTML = content.innerHTML;
      } catch (error) {
        // Keep the existing choices if a background refresh fails.
      }
    }
  }
  customElements.define('rovixo-product-complements', RovixoProductComplements);
})();
